const userRoleType = {
  GlobalAdministrator: 10,
  MissionAdministrator: 110,
  TemplateBuilder: 120,
  CheckListManager: 130,
};

export default userRoleType;
